import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import type { TokenPayload } from '../types';

interface Props {
  allowedRoles?: Array<TokenPayload['role']>;
}

/**
 * Renders child routes if authenticated (and optionally matching an allowed role).
 * Redirects to /login otherwise.
 */
export default function ProtectedRoute({ allowedRoles }: Props) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated());
  const role = useAuthStore((s) => s.role());

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && role && !allowedRoles.includes(role)) {
    // Redirect to the role's own dashboard
    return <Navigate to={`/${role}/dashboard`} replace />;
  }

  return <Outlet />;
}
